export default "__VITE_ASSET__C42wDcUl__"